import { FieldValues, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { IEmpOneOfMany, IEmpUser } from '@/models'
import { Text } from '@/components/ui'
import { SelectAnswer } from '../ui'

interface IEmpOneOfManyQuestionProps {
  question: IEmpOneOfMany
  register: UseFormRegister<FieldValues>
  setValue: UseFormSetValue<FieldValues>
}

const EmpOneOfManyQuestion = ({ question, register, setValue }: IEmpOneOfManyQuestionProps) => {
  const usersLength: number = question?.users?.length

  if (!usersLength) {
    return (
      <Text as='p' size='md'>
        Нет сотрудников для оценки. Можете продолжить опрос
      </Text>
    )
  }

  return (
    <>
      {question.users.map((user: IEmpUser) => (
        <SelectAnswer
          key={user.uuid}
          name={String(question.id)}
          register={register}
          value={user.uuid}
          type='radio'
          onChange={(e) => {
            e.preventDefault()
            setValue(String(question.id), user.uuid)
          }}
        >
          <Text>{user?.title}</Text>
        </SelectAnswer>
      ))}
    </>
  )
}

export default EmpOneOfManyQuestion
